/* soolla-stamp-marquee.js — <soolla-stamp-marquee> UK postage-stamp wave. Zero dependencies.
   Union Jack stamps march right → left along a smooth cosine wave, tilting with the curve.
   Motion is pure CSS offset-path (GPU-composited, no JS per frame).

   <soolla-stamp-marquee speed="28" height="136" amp="26" label="SOOLLA · AIR MAIL"></soolla-stamp-marquee>

   speed    px per second along the wave            default 28
   height   band height in px                        default 136
   amp      wave amplitude in px                     default 26
   spacing  approx px between stamps                 default 132
   label    caption printed under the flag           default "SOOLLA · AIR MAIL"
   size     stamp width in px (height follows 92:70)   default 92   [theme addition 2026-09-29]
   CSS: --ssm-font sets the caption font (defaults to National 2 Narrow). Place it full-bleed
   (width:100%) so stamps enter/exit off-screen rather than clipping against a container edge. */
(function () {
  if (customElements.get("soolla-stamp-marquee")) return;

  var css = "soolla-stamp-marquee{display:block;position:relative;overflow:hidden;pointer-events:none}" +
    "soolla-stamp-marquee .ssm-i{position:absolute;left:0;top:0;offset-rotate:auto;offset-anchor:center;animation:ssm-march linear infinite;will-change:offset-distance;line-height:0}" +
    "soolla-stamp-marquee .ssm-s{display:block;filter:drop-shadow(1.5px 2.5px 2px rgba(20,17,15,.25))}" +
    "@keyframes ssm-march{from{offset-distance:100%}to{offset-distance:0%}}" +
    "@media (prefers-reduced-motion:reduce){soolla-stamp-marquee .ssm-i{animation-play-state:paused}}";
  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  var UNION_JACK =
    '<rect width="300" height="200" fill="#012169"/>' +
    '<path d="M0,0 L300,200 M300,0 L0,200" stroke="#F5F2EC" stroke-width="40"/>' +
    '<path d="M0,0 L300,200 M300,0 L0,200" stroke="#C8102E" stroke-width="14"/>' +
    '<path d="M150,0 V200 M0,100 H300" stroke="#F5F2EC" stroke-width="62"/>' +
    '<path d="M150,0 V200 M0,100 H300" stroke="#C8102E" stroke-width="36"/>';

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function wavePath(w, H, A) {
    var freq = Math.PI * 2 * 2.2, pts = [];
    for (var x = -110; x <= w + 130; x += 55) pts.push([x, H / 2 + A * Math.cos((x / w) * freq)]);
    var d = "M" + pts[0][0] + "," + pts[0][1].toFixed(1);
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[Math.max(0, i - 1)], p1 = pts[i], p2 = pts[i + 1], p3 = pts[Math.min(pts.length - 1, i + 2)];
      d += " C" + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + "," + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + " " +
        (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + "," + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + " " + p2[0] + "," + p2[1].toFixed(1);
    }
    return d;
  }

  var uid = 0;
  class SoollaStampMarquee extends HTMLElement {
    static get observedAttributes() { return ["speed", "height", "amp", "spacing", "label", "size"]; }
    constructor() { super(); this.id_ = "ssm" + (++uid); this.w = 0; }
    connectedCallback() {
      this.setAttribute("aria-hidden", "true");
      var self = this;
      this.ro = new ResizeObserver(function () {
        var w = self.offsetWidth; if (Math.abs(w - self.w) > 1) { self.w = w; self._build(); }
      });
      this.ro.observe(this);
      this.w = this.offsetWidth; this._build();
    }
    disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
    attributeChangedCallback() { if (this.isConnected) this._build(); }
    _num(k, d) { var v = parseFloat(this.getAttribute(k)); return isNaN(v) ? d : v; }
    _build() {
      var w = Math.max(480, this.w || this.offsetWidth || 1200);
      var H = this._num("height", 136), A = this._num("amp", 26), speed = Math.max(1, this._num("speed", 28));
      var n = Math.max(8, Math.round(w / this._num("spacing", 132)));
      var sw = Math.max(24, this._num("size", 92)), shh = Math.round(sw * 70 / 92);
      var label = this.getAttribute("label") || "SOOLLA \u00B7 AIR MAIL";
      var long = label.length > 19, id = this.id_;
      var dur = (w + 240) / speed;
      var path = wavePath(w, H, A);
      /* phase from the wall clock so a resize rebuild doesn't visibly jump back to the start */
      var phase = (performance.now() / 1000) % dur;
      var xs = [22, 50, 78, 106, 134], ys = [10, 34, 58, 82, 106], holes = "";
      ys.forEach(function (y) { holes += '<circle cx="0" cy="' + y + '" r="6"/><circle cx="164" cy="' + y + '" r="6"/>'; });
      xs.forEach(function (x) { holes += '<circle cx="' + x + '" cy="0" r="6"/><circle cx="' + x + '" cy="124" r="6"/>'; });
      var defs =
        '<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs>' +
        '<mask id="' + id + '-m" maskUnits="userSpaceOnUse" x="0" y="0" width="164" height="124"><rect width="164" height="124" rx="6" fill="#fff"/><g fill="#000">' + holes + "</g></mask>" +
        '<symbol id="' + id + '-s" viewBox="0 0 164 124"><g mask="url(#' + id + '-m)">' +
        '<rect width="164" height="124" fill="#fff"/>' +
        '<svg x="14" y="13" width="136" height="80" viewBox="0 0 300 200" preserveAspectRatio="xMidYMid slice">' + UNION_JACK + "</svg>" +
        '<text x="82" y="112" text-anchor="middle" style="font-family:var(--ssm-font,\'National 2 Narrow\',\'Arial Narrow\',sans-serif)" font-weight="800" font-size="' + (long ? 9.5 : 10.5) + '" letter-spacing="' + (long ? 1.2 : 2.5) + '" fill="rgba(20,17,15,.65)">' + esc(label) + "</text>" +
        "</g></symbol></defs></svg>";
      var items = "";
      for (var i = 0; i < n; i++) {
        var delay = -(phase + (i * dur) / n);
        items += '<div class="ssm-i" style="offset-path:path(\'' + path + '\');animation-duration:' + dur.toFixed(2) + "s;animation-delay:" + delay.toFixed(2) + 's">' +
          '<svg class="ssm-s" width="' + sw + '" height="' + shh + '" viewBox="0 0 164 124"><use href="#' + id + '-s"/></svg></div>';
      }
      this.style.height = H + "px";
      this.innerHTML = defs + items;
    }
  }
  customElements.define("soolla-stamp-marquee", SoollaStampMarquee);
})();
